import React, { useState } from 'react';
import DOMPurify from 'dompurify';
import { Link } from 'react-router-dom';
import { capitalizeFirstLetter } from '../../utils/letters'

function Course({ courseData, isLoading, limitHome }) {
    const asesorias = Array.isArray(courseData) ? courseData : [];
    const [hoveredKey, setHoveredKey] = useState(null);

    const traducirModalidad = (modalidad) => {
        if (modalidad === 'sync') return 'Sincrónico';
        if (modalidad === 'async') return 'Asincrónico';
        if (modalidad === 'mixed') return 'Mixto';
        if (modalidad === 'presencial') return 'Presencial';
        return modalidad || 'No definida';
    };

    const getAprenderasItems = (curso) => {
        if (curso.objectives && typeof curso.objectives === 'string') {
            return curso.objectives
                .split(/\n+/)
                .map((s) => s.replace(/^\d+[.)]\s*/, '').trim())
                .filter(Boolean)
                .slice(0, 3);
        }
        return [
            'Acceder a materiales y contenidos del curso',
            'Participar en las evaluaciones',
            'Consultar al docente por mensajes',
        ].slice(0, 3);
    };

    return (
        <>
            <section className="tittle-course tittle-course--with-link">
                <div className="tittle-course-left">
                    <div className="titt-c">
                        <span>Cursos</span>
                    </div>
                    <div className="div-course">
                        <i className="ri-star-fill star-icon"></i>
                        <span>Más solicitados</span>
                    </div>
                </div>
                {limitHome && (
                    <Link to="/cursos" className="btn-ver-todos btn-ver-todos-course"><i className="ri-menu-search-line d-inline d-md-none"></i><span className="d-none d-md-inline">Ver todos los cursos</span></Link>
                )}
            </section>
            <section className="carousel-wrapper">
                {isLoading ? (
                    <div className="loader-container">
                        <img src="/icon/carga-puntos.svg" alt="Cargando asesorias Somnus" style={{ width: '180px', height: 'auto' }} />
                        <p className="txt-loading">Buscando cursos...</p>
                    </div>
                ) : (
                    <>
                        {asesorias.length > 0 && (
                            <button type="button" className="nav-arrow left" onClick={() => document.querySelector('.section-course-container')?.scrollBy({ left: -300, behavior: 'smooth' })}>
                                <i className="ri-arrow-left-s-line"></i>
                            </button>
                        )}
                        <section className="section-course-container">
                            {asesorias.length > 0 ? (
                                asesorias.map((curso, index) => {
                                    const key = curso.code || curso.id || index;
                                    const isHovered = hoveredKey === key;
                                    const aprenderas = getAprenderasItems(curso);
                                    return (
                                        <div
                                            className={`course-card-wrapper ${isHovered ? 'is-hovered' : ''}`}
                                            key={key}
                                            onMouseEnter={() => setHoveredKey(key)}
                                            onMouseLeave={() => setHoveredKey(null)}
                                        >
                                            <div className="course-card">
                                                <div className="img-wrapper">
                                                    <img src={curso.image || "/img/course/puntos.webp"} alt={curso.name} />
                                                </div>
                                                <div className="card-content">
                                                    <span className="label-course">Cursos</span>
                                                    <p className="course-name">{capitalizeFirstLetter(curso.name)}</p>
                                                    <div className="course-card-detail">
                                                        <div className="course-card-detail-inner">
                                                            <p className="course-card-learn-title">Aprenderás cómo</p>
                                                            <ul className="course-card-learn-list">
                                                                {aprenderas.map((item, i) => (
                                                                    <li key={i}>
                                                                        <i className="ri-checkbox-circle-fill" aria-hidden />
                                                                        <div
                                                                            className="valores-body-text point-course"
                                                                            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(item) }}
                                                                        />
                                                                    </li>
                                                                ))}
                                                            </ul>
                                                        </div>
                                                    </div>
                                                    <div className="course-info-row">
                                                        <div className="info-item">
                                                            <i className="ri-calendar-line"></i>
                                                            <span>Inicio: {curso.start_date || "Por definir"}</span>
                                                        </div>
                                                        <div className="info-item">
                                                            <i className="ri-time-line"></i>
                                                            <span>{curso.duration_text || "Por definir"}</span>
                                                        </div>
                                                        <div className="info-item">
                                                            <i className="ri-money-dollar-circle-line"></i>
                                                            <span>{curso.price || "Por definir"}</span>
                                                        </div>
                                                        <div className="info-item">
                                                            <i className="ri-macbook-line"></i>
                                                            <span>{traducirModalidad(curso.modality)}</span>
                                                        </div>
                                                        <Link to={`/curso/${curso.code}`}>
                                                            <button type="button"><span>Ver detalles</span></button>
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })
                            ) : (
                                <span className="txt-resp">No hay cursos disponibles en este momento.</span>
                            )}
                        </section>
                        {asesorias.length > 0 && (
                            <button type="button" className="nav-arrow right" onClick={() => document.querySelector('.section-course-container')?.scrollBy({ left: 300, behavior: 'smooth' })}>
                                <i className="ri-arrow-right-s-line"></i>
                            </button>
                        )}
                    </>
                )}
            </section>
        </>
    );
}

export default Course;